/**
 * Části zájezdu, které API při ZALOŽENÍ ukládá až po zápisu řádku a které se proto nemusí
 * uložit (odpověď 201 je jmenuje v `unsavedParts`, jen při neúplném uložení). Výčet sdílí
 * producent (`POST /api/admin/trips`) i konzument (pruh v editoru adminu); pořadí je pořadí
 * editoru.
 */
export const UNSAVED_TRIP_PARTS = ["upgrades", "dates", "components"] as const;

export type UnsavedTripPart = (typeof UNSAVED_TRIP_PARTS)[number];
